module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//10.jpg?316c43174422498c5dbd00dc695a89e6";